// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"325f9474","564":"2f951a32","705":"70885a9b","834":"14ef923d"}[chunkId] + ".chunk.js";
};